/** Short label for table headers (web + mobile). */
export const COURSE_CYCLE_COLUMN_LABEL = 'Cycle';

/** Full explanation — shown in tooltip / aria-label only. */
export const COURSE_CYCLE_TOOLTIP =
  'Classes attended out of planned in this 3-month block. The total includes future sessions—it is not a count of absences.';

export function formatCycleDate(ymd) {
  if (!ymd) return '';
  const iso = String(ymd).slice(0, 10);
  const d = new Date(`${iso}T12:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

export function formatCycleRange(start, end) {
  const a = formatCycleDate(start);
  const b = formatCycleDate(end);
  if (!a || !b) return null;
  return `${a}–${b}`;
}

export function getCourseCycleStats(classesCompleted, progressDenominator) {
  const done = Number(classesCompleted) || 0;
  const planned = Number(progressDenominator) || 0;
  return { done, planned, hasCycle: planned > 0 };
}

export function getCourseCycleTooltip({ done, planned, hasCycle, rangeLabel }) {
  if (!hasCycle) {
    return done === 1 ? '1 class attended' : `${done} classes attended`;
  }
  const period = rangeLabel ? ` (${rangeLabel})` : '';
  return `Attended ${done} of ${planned} planned classes in this cycle${period}. Future classes are included in the total.`;
}
